/**
 * La grosse pastille d'HORA du déblocage d'un Move : « +500 HORA » surgit au centre de l'écran avec le nom
 * du Move, puis s'envole. Ces HORA sont GLOBALES (le « HORA cumulé » du tableau de bord) : la pastille ne
 * touche ni la feuille ni l'exercice en cours.
 */
import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { formatHoraGain } from '@jeraisonne/db/cards';
import './move-panel.css';

/** Le temps de la pastille à l'écran, envol compris. */
export const HORA_REWARD_MS = 2600;

export interface HoraReward {
  /** relance l'animation quand deux Moves se suivent */
  seq: number;
  name: string;
  hora: number;
  kind: 'savoir' | 'geste';
}

export function HoraRewardPop({
  reward,
  onDone,
}: {
  reward: HoraReward | null;
  onDone: () => void;
}) {
  useEffect(() => {
    if (!reward) return;
    const t = window.setTimeout(onDone, HORA_REWARD_MS);
    return () => window.clearTimeout(t);
    // une nouvelle récompense relance le minuteur
  }, [reward?.seq]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!reward || typeof document === 'undefined') return null;
  return createPortal(
    <div className="jr-hora-pop" data-kind={reward.kind} key={reward.seq} data-testid="hora-reward">
      <div className="jr-hora-pop-coin">
        <span className="jr-hora-pop-gain">{formatHoraGain(reward.hora)}</span>
      </div>
      <p className="jr-hora-pop-name">
        {reward.kind === 'geste' ? 'Geste débloqué' : 'Connaissance débloquée'} : {reward.name}
      </p>
      <p className="sr-only" role="status">
        Move débloqué : {reward.name}. Tu gagnes {reward.hora} HORA.
      </p>
    </div>,
    document.body,
  );
}
